export var SPINNER_CONTAINER_SIZES_MAP = {
  small: 10,
  medium: 16,
  xLarge: 28
};
export var SPINNER_DOT_SIZES_MAP = {
  small: 3,
  medium: 4,
  xLarge: 7
};
//# sourceMappingURL=constants.js.map